
/* ========================================================================
 * 
 * Custom site functions
 * 
 * ======================================================================== */

$(function() {

/* ------------------------------------------------------------------------
 * Give the BBB seals a few seconds to load
 * ------------------------------------------------------------------------ */
   
   setTimeout( function(){
      $('.js__bbb_seal_loading').css('visibility', 'visible');
   }, 2000 );

/* ------------------------------------------------------------------------
 * Collapse the section nav
 * ------------------------------------------------------------------------ */
   
   // Listen for the expand button
   $(document).on('click', '.js__uncollapse-sectionnav', function(event){
      event.stopPropagation();
      event.preventDefault();

      _$hidden = $('.collapsed');
      _$hidden.removeClass('collapsed');
      $(this).remove();
   });

   // Collapse the section nav
   $('.sectionnav-inner ul.sub-menu').each( function(){

      _$this = $(this);
      _$items = $('.li', this );
      var _show = 4;
      var _count = 0;
      var _collapsed = false;

      // Collapse the extra items
      $(this).find('li').each(function(){
         if (++_count > _show) {
            if (!$(this).hasClass('current-menu-item')) {
               $(this).addClass('collapsed');
               _collapsed = true;
            }
         }
      });

      // Add the expand link
      if (_collapsed) {
         $("li:last", _$this).after('<li><a href="#" class="sectionnav-more js__uncollapse-sectionnav">Show More</a></li>');
      }
   });

/* ------------------------------------------------------------------------
 * If a submenu item is selected in the section nav, 
 * un-highlight the parent item
 * ------------------------------------------------------------------------ */
   $('.sub-menu li.current-menu-item').parent().closest('.current-menu-item').addClass('current-menu-item-parent');

/* ------------------------------------------------------------------------
 * Hide certain elements while the window is resizing. Used primarily to 
 * make the slideshow redraw smoother, since it is showing a set if iframes
 * which also need to redraw
 * ------------------------------------------------------------------------ */

   var showHandler;
   var windowWidth = $(window).width();

   $(window)
      .resize( $.debounce( 500, true, function(e){

         // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
         if ($(window).width() != windowWidth) {

            // Update the window width for next time
            windowWidth = $(window).width();

            // Hide the items
            $('.js__hide_while_resizing').css('visibility', 'hidden');

            // Wait for .5s, and then show them
            showHandler = setTimeout( function(){
               $('.js__hide_while_resizing').css('visibility', 'visible');
            }, 500);
         
         }
   }));

/* ------------------------------------------------------------------------
 * Start the subcategory banner slideshows
 * ------------------------------------------------------------------------ */
   
   $('.js__slick_subcategories').each(function(){ 

      var _subcategory_slider;

      $('.js__slick_subcategories').on('beforeChange', function(event, slick, currentSlide, nextSlide){

         _$currentSlide = $(slick.$slides.get(nextSlide));
         _current_href = window.location;
         _href = $('.banner-subcategory-list-item', _$currentSlide).attr('data-href');

         if (_href != _current_href) {         
            $('.banner-subcategory-list-item', _$currentSlide).addClass('banner-subcategory-list-item-fadein');
            $('.banner-subcategory-list-item-active').addClass('banner-subcategory-list-item-fadeout');
            window.location = _href;
         }
      });

      $('.js__slick_subcategories').on('init', function(event, slick, currentSlide, nextSlide){
         $('.banner-subcategory-list').css('visibility', 'visible')
      });

      _subcategory_slider = $('.js__slick_subcategories_many').slick({
         dots: true,
         mobileFirst: true,
         speed: 500,
         initialSlide: parseInt($_initialSlide),
         slidesToShow: 3,
         centerMode: true,
         focusOnSelect: true,
         touchThreshold: 7,
         responsive: [
            {
            breakpoint: 1300,
            settings: {
               slidesToShow: 3
               }
            }
         ]
      });

      _subcategory_slider = $('.js__slick_subcategories_one').slick({
         dots: true,
         mobileFirst: true,
         speed: 500,
         centerMode: true,
         focusOnSelect: true,
         responsive: [
            {
            breakpoint: 1300
            }
         ]
      });

      _subcategory_slider = $('.js__slick_subcategories_two').slick({
         dots: true,
         mobileFirst: true,
         speed: 500,
         initialSlide: parseInt($_initialSlide),
         centerMode: true,
         focusOnSelect: true,
         touchThreshold: 7,
         responsive: [
            {
            breakpoint: 1300,
            settings: {
               slidesToShow: 3,
               }
            }
         ]
      });

      _subcategory_slider = $('.js__slick_subcategories_three').slick({
         dots: true,
         mobileFirst: true,
         speed: 500,
         initialSlide: parseInt($_initialSlide),
         centerMode: true,
         focusOnSelect: true,
         touchThreshold: 7,
         responsive: [
            {
            breakpoint: 1300,
            settings: {
               slidesToShow: 3,
            }
            }
         ]
      });
   });

/* ------------------------------------------------------------------------
 * Start the banner slideshow
 * ------------------------------------------------------------------------ */
   
   $('.js__slick_banner').slick({
      dots: true,
      mobileFirst: true,
      speed: 500,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1
   });

/* ------------------------------------------------------------------------
 * Start the testimonial slideshows
 * ------------------------------------------------------------------------ */
   
   // On slideshow init/redraw
   $('.js__slick_testimonials').on('init breakpoint', function(event, slick, currentSlide, nextSlide){
      
      $('.js__slick_testimonials').each( function(){

         // Show the parent container
         $_this = $(this);
         $('.cta-testimonials-layer3 .testimonial-list').css('visibility', 'visible');

         // Are we showing all the items? If so, format things a bit differently
         $_active_count = $('.js__slick_testimonials .slick-active').length;
         $_total_count = $('.js__slick_testimonials .slick-slide').length;

         if ($_active_count != $_total_count) {

            // Unmark the items as all-shown
            $('.js__slick_testimonials .slick-slide').removeClass('all-shown');

            // Add the secondary 'green' prev/next buttons
            $_prev = $.parseHTML('<div class="slick-prev-secondary">More</div>');
            $_next = $.parseHTML('<div class="slick-next-secondary">More</div>');
            $_prevObj = $_this.append( $_prev );
            $_nextObj = $_this.append( $_next );

            // Make the secondary 'green' prev/next buttons functional
            $_this.on('click', '.slick-prev-secondary', function() {
               $('.slick-prev', $_this).trigger('click');
            });

            $_this.on('click', '.slick-next-secondary', function() {
               $('.slick-next', $_this).trigger('click');
            });

            
         }

         else {

            // Mark the items as all-shown
            $('.js__slick_testimonials .slick-slide').addClass('all-shown');

         }

         
         $('.slick-slide').removeClass('last-active');
         $('.slick-slide.slick-active').last().addClass('last-active');
      });
   });

   $('.js__slick_testimonials').on('afterChange', function(event, slick, currentSlide, nextSlide){
      $('.slick-slide').removeClass('last-active');
      $('.slick-slide.slick-active').last().addClass('last-active');

   });

   $('.cta-testimonials-layer3 .testimonial-list').css('visibility', 'hidden');

    $('.js__slick_testimonials').slick({
        dots: true,
        mobileFirst: true,
        speed: 500,
        touchMove: true,
        responsive: [
            {
                breakpoint: 1120,
                settings: {
                slidesToShow: 3
                }
            },
            {
                breakpoint: 1600,
                settings: {
                slidesToShow: 5
                }
            },
        ]
    });

 /* ------------------------------------------------------------------------
 * Defer-load slow element
 * ------------------------------------------------------------------------ */
   var deferElements = $('.defer-load');

   function decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
  }

   var loadDeferredElement = function( elem ) {
      _src = decodeHtml( $(elem).attr('data-src' ) );
      $(elem).replaceWith( _src );
   };

   deferElements.each( function( idx, elem ) {

      timeoutTime = idx * 200;
      setTimeout(loadDeferredElement.bind(null, elem), timeoutTime);

   });

   
   

 /* ------------------------------------------------------------------------
 * Load the ticker
 * ------------------------------------------------------------------------ */
   
   $.ajax({
      url: ajaxurl,
      data: {
         'action': 'load_ticker',
      },      
      success:function(data) {
         
         // Load the data via an ajax call, to avoid server-level caching
         $('.js__ticker-inner').html( data );

      },
   });
   

});
